(function () {
  const OPEN_CLASS = "mmd-open";
  const DESKTOP_MQ = window.matchMedia("(min-width: 990px)");

  function qs(sel, root = document) {
    return root.querySelector(sel);
  }
  function qsa(sel, root = document) {
    return Array.from(root.querySelectorAll(sel));
  }

  function getEls() {
    const drawer = qs("[data-mmd-drawer]");
    const overlay = qs("[data-mmd-overlay]");
    const panel = drawer ? drawer.querySelector(".mmd__panel") : null;
    return { drawer, overlay, panel };
  }

  function openDrawer() {
    if (DESKTOP_MQ.matches) return;

    const { drawer, overlay, panel } = getEls();
    if (!drawer || !overlay || !panel) return;

    overlay.hidden = false;
    drawer.hidden = false;
    drawer.setAttribute("aria-hidden", "false");

    // forza layout: stato iniziale (translateX) già applicato
    panel.getBoundingClientRect();

    // anima al frame successivo
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        document.body.classList.add(OPEN_CLASS);
      });
    });
  }

  function closeDrawer() {
    const { drawer, overlay, panel } = getEls();
    if (!drawer || !overlay || !panel) return;

    document.body.classList.remove(OPEN_CLASS);
    drawer.setAttribute("aria-hidden", "true");

    // chiudi accordion
    qsa("[data-mmd-trigger]").forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
      const mega = btn.nextElementSibling;
      if (mega) mega.hidden = true;
    });

    const onEnd = (e) => {
      if (e.target !== panel) return;
      panel.removeEventListener("transitionend", onEnd);
      overlay.hidden = true;
      drawer.hidden = true;
    };

    panel.addEventListener("transitionend", onEnd);

    // fallback sicurezza se transitionend non arriva
    window.setTimeout(() => {
      if (!document.body.classList.contains(OPEN_CLASS)) {
        overlay.hidden = true;
        drawer.hidden = true;
        panel.removeEventListener("transitionend", onEnd);
      }
    }, 400);
  }

  function toggleAccordion(btn) {
    const expanded = btn.getAttribute("aria-expanded") === "true";
    const mega = btn.nextElementSibling;
    if (!mega) return;

    qsa("[data-mmd-trigger]").forEach((b) => {
      if (b === btn) return;
      b.setAttribute("aria-expanded", "false");
      const m = b.nextElementSibling;
      if (m) m.hidden = true;
    });

    btn.setAttribute("aria-expanded", expanded ? "false" : "true");
    mega.hidden = expanded;
  }

  document.addEventListener("click", (e) => {
    const openBtn = e.target.closest("[data-mmd-open]");
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }

    const closeBtn = e.target.closest("[data-mmd-close]");
    if (closeBtn) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    const overlay = e.target.closest("[data-mmd-overlay]");
    if (overlay) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    const trigger = e.target.closest("[data-mmd-trigger]");
    if (trigger) {
      e.preventDefault();
      toggleAccordion(trigger);
      return;
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeDrawer();
  });

  // se passi a desktop mentre è aperto → chiudi
  DESKTOP_MQ.addEventListener?.("change", (ev) => {
    if (ev.matches) closeDrawer();
  });
})();
